// removed by extract-text-webpack-plugin
module.exports = {"Content":"Layout__Content__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/Layout.css
// module id = 58
// module chunks = 0